<section class="page-section overlay scrollbar">
    <div class="overlay-center-parent">
        <div class="overlay-center-child">
            <div class="row">
                <div class="col-0 col-md-1 col-xl-2 hide-xs-sm"></div>
                <div class="col-12 col-md-10 col-xl-8">
                    <div class="overlay-card">

                        <ng-container *ngIf="success === null">
                            <header class="page-title-bar">
                                <h1 class="page-title" id="helpTitle">Drop us a message if ever you need help.</h1>
                            </header>

                            <div class="row row-form">
                                <div class="col-12">
                                    <input type="text" name="email" id="email" placeholder="Name" [(ngModel)]="ticket.email" class="form-input form-control form-control-required" [ngClass]="{'form-control-invalid': showErrors && !emailValid}">
                                    <label for="email">
                                        Email address
                                        <span class="compulsory-field" placement="top" ngbTooltip="This field is required"></span>
                                    </label>
                                    <span id="emailError" *ngIf="showErrors && !emailValid" class="validation-warning">Please enter a valid email address.</span>
                                </div>
                            </div>

                            <div class="row row-form">
                                <div class="col-12">
                                    <select name="subject" id="subject" class="form-input form-control-select form-control-required" [ngClass]="{'is-invalid': showErrors && !subjectValid}" [(ngModel)]="ticket.subject" required>
                                        <option></option>
                                        <option *ngFor="let subject of subjects">{{subject}}</option>
                                    </select>
                                    <label for="subject">
                                        Needing assistance with...
                                        <span class="compulsory-field" placement="top" ngbTooltip="This field is required"></span>
                                    </label>
                                    <span id="subjectError" *ngIf="showErrors && !subjectValid" class="validation-warning">Please select the subject.</span>
                                </div>
                            </div>

                            <div class="row row-form" id="description">
                                <div class="col-12">
                                    <label>
                                        Description
                                        <span class="compulsory-field" placement="top" ngbTooltip="This field is required"></span>
                                    </label>
                                    <ejs-richtexteditor #wysiwyg id='wysiwyg' class="form-control-required" [ngClass]="{'wysiwyg-is-invalid': showErrors && !descriptionValid}" [toolbarSettings]='editorTools' [showCharCount]='false' [enableTabKey]='true' [(value)]="ticket.description"></ejs-richtexteditor>
                                    <span id="descriptionError" *ngIf="showErrors && !descriptionValid" class="validation-warning validation-warning-wysiwyg">Please enter the description.</span>
                                </div>
                            </div>
                            <div class="row row-form">
                                <div class="col-12">
                                    <input type="file" multiple [hidden]="true" name="fileInput" id="fileInput" class="form-input form-control selected" (input)="attachFile($event)">
                                    <div>
                                        <input type="text" name="attachments" id="attachments" class="form-input form-control" value="Click here to attach files." (click)="openFilePicker()" readonly>
                                        <label for="attachments">Attachments</label>
                                    </div>
                                    <span id="fileError" *ngIf="fileError" class="validation-warning">{{fileError}}</span>

                                    <p *ngIf="ticket.attachments && ticket.attachments.length >= 1">
                                        <ng-container *ngFor="let attachment of ticket.attachments">
                                            <span class="support-attachments">
                                                <i class="fa-solid fa-file fa-padding-right"></i>
                                                {{attachment.name}}
                                                <a [routerLink]="" (click)="removeFile(attachment.name)"><i class="fa-light fa-trash support-fa-padding"></i></a>
                                            </span>
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                            
                            <ng-template #diagInfo>
                                Diagnostic information:
                                <div [innerHTML]="diagnosticInformation"></div>
                            </ng-template>
                            
                            <div class="row row-form">
                                <div class="col-12">
                                    <div class="checkbox with-tooltip">
                                        <input type="checkbox" name="sendDiagInfo" id="sendDiagInfo" class="hide-checkbox" [(ngModel)]="canSendDiagInfo">
                                        <label for="sendDiagInfo" class="non-floating-checkbox-label has-tooltip-at-end">
                                            Send diagnostic information?
                                        </label>
                                        <a>
                                            <i placement="auto" [ngbTooltip]="diagInfo" class="fas fa-primary-top fa-circle-info"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="row row-form" *ngIf="!isLoggedIn">
                                <div class="col-12 text-left">
                                    <div id="recaptcha" class="recaptcha" *ngIf="recaptchaSiteKey">
                                        <re-captcha (resolved)="resolved($event)" (expired)="recaptchaExpired()" [siteKey]="recaptchaSiteKey"></re-captcha>
                                        <span id="recaptchaError" *ngIf="showErrors && !recaptchaValid" class="validation-warning validation-warning-recaptcha">Please confirm you are not a robot.</span>
                                    </div>
                                </div>
                            </div>
                            <!-------------------------------------------- BUTTONS -------------------------------------------->
                            <div class="row">
                                <div class="col-12 col-lg-4 text-align-center btn-order-left"></div>
                                <div class="col-12 col-lg-4 text-align-center btn-order-left">
                                    <button type="button" class="btn btn-secondary-v2 btn-margins btn-label btn-label-cancel" (click)="close()"><span class="btn-icon btn-icon-cancel"></span></button>
                                </div>
                                <div class="col-12 col-lg-4 text-align-center btn-order-right">
                                    <button type="submit" id="btnSubmit" (click)="submit()" *ngIf="!isSaving" [ngClass]="{'btn-primary-v2':submitActive, 'btn-primary-v2-inactive':!submitActive}"
                                            class="btn-primary-v2 btn btn-primary-mini btn-margins btn-label btn-label-submit">
                                        <span class="btn-icon btn-icon-submit"></span>
                                    </button>
                                    <app-spinner [show]="isSaving"></app-spinner>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="success !== null && success == true">
                            <header class="page-title-bar">
                                <h1 class="page-title">We received your request.</h1>
                            </header>

                            <div class="row row-form">
                                <div class="col-12">
                                    <p>A member of our client support team will respond as soon as possible.</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-lg-4 text-align-center btn-order-left"></div>
                                <div class="col-12 col-lg-4 text-align-center btn-order-left">
                                    <button type="button" class="btn btn-secondary-v2 btn-margins btn-label btn-label-close" (click)="close()"><span class="btn-icon btn-icon-close"></span></button>
                                </div>
                                <div class="col-12 col-lg-4 text-align-center btn-order-right"></div>
                            </div>

                        </ng-container>

                        <ng-container *ngIf="success !== null && success == false">
                            <header class="page-title-bar">
                                <h1 class="page-title">Contact our client support team</h1>
                            </header>

                            <div class="row row-form">
                                <div class="col-12">
                                    <h3>
                                        Your request failed to send, please contact our support team using another method below.<br />
                                        Our client support teams, based in New Zealand and the UK, are available to help you during business hours. You can reach them by phone or email,
                                        whichever
                                        is more convenient.
                                    </h3>
                                    <ul style="list-style: none">
                                        <li>
                                            Email:
                                            <ul>
                                                <li><a [routerLink]="" (click)="mailTo()"><p>help&#64;fecpak.com</p></a></li>
                                            </ul>
                                        </li>

                                        <li>
                                            New Zealand:
                                            <ul>
                                                <li>0800 330 725</li>
                                                <li>+64 3 477 7555</li>
                                            </ul>
                                        </li>

                                        <li>
                                            Australia:
                                            <ul>
                                                <li>1800 573 247</li>
                                            </ul>
                                        </li>

                                        <li>
                                            UK and Europe:
                                            <ul>
                                                <li>+44 0 1970 821 918</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-lg-4 text-align-center btn-order-left"></div>
                                <div class="col-12 col-lg-4 text-align-center btn-order-left">
                                    <button type="button" class="btn btn-secondary-v2 btn-margins btn-label btn-label-close" (click)="close()">
                                        <span class="btn-icon btn-icon-close"></span>
                                    </button>
                                </div>
                                <div class="col-12 col-lg-4 text-align-center btn-order-right"></div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="col-1 col-md-1 col-xl-2 hide-xs-sm"></div>
            </div>
        </div>
    </div>
</section>